export const pluginId = 'scorecard';
